module.exports = {"theme":{"screens":{"sm":"640px","md":"768px","lg":"1024px","xl":"1280px","2xl":"1536px","xs":"340px","3xl":"2340px"}}}